import { Link } from "react-router-dom";
import { glossaryHref } from "../content/siteCatalog";

/** Shared blue link style for glossary terms and external references. */
export const REFERENCE_LINK_CLASS =
  "font-semibold text-info underline decoration-info/40 underline-offset-2 hover:decoration-info";

interface GlossaryLinkProps {
  termId: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

/** Deep-link into the Science page Labels & terminology glossary. */
export function GlossaryLink({
  termId,
  children,
  className = REFERENCE_LINK_CLASS,
  title,
  "aria-label": ariaLabel,
}: GlossaryLinkProps) {
  return (
    <Link
      to={glossaryHref(termId)}
      className={className}
      title={title}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
}
